$(function() {
  var currentAjaxRequest = null;
  var searchResultSlider = null; 

  function highlightTerm(text, term) {
    if (!term) return text;
    var regex = new RegExp('(' + term + ')', 'ig');
    return text.replace(regex, '<strong>$1</strong>');
  }

  function initSearchSlider() {
    const searchUl = $(".mboile-search-content .search-results");
    if (!searchUl || searchUl.hasClass("swiper-wrapper")) return;

    const items = searchUl.find("li:not(.view-all-search)");
    const viewAll = searchUl.find(".view-all-search");

    if (!items.length) return;

    searchUl.addClass("swiper-wrapper");

    const wrapper = $("<div class='swiper search-results-slider'></div>");
    searchUl.wrap(wrapper);

    // Add navigation buttons if not already present
    if (!$(".swiper-button-prev").length) {
      const prev = $("<div class='swiper-button-prev'></div>");
      const next = $("<div class='swiper-button-next'></div>");
      searchUl.parent().append(prev).append(next);
    }

    // Re-insert the "view all" link if it exists
    if (viewAll.length) {
      searchUl.parent().after(viewAll);
    }

    if (searchResultSlider instanceof Swiper) {
      searchResultSlider.destroy(true, true);  // Destroy previous instance
      searchResultSlider = null;  // Clear the reference
    }

    // Initialize Swiper
    searchResultSlider = new Swiper(".search-results-slider", {
      slidesPerView: 2,
      spaceBetween: 0,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      }
    });
  }

  $('form[action="/search"]').css('position','relative').each(function() {
    var input = $(this).find('input[name="q"]');
    var offSet = input.position().top + input.innerHeight();

    // Create wrapper for summary + results
    var wrapper = $('<div class="search-wrapper"></div>')
      .appendTo($(this))
      .hide();

    var summary = $('<div class="serach-drawer-details"></div>').appendTo(wrapper);
    var resultsList = $('<ul class="search-results" role="listbox"></ul>').appendTo(wrapper);

    input.attr('autocomplete', 'off');

    let debounceTimer;
    input.on('keyup change', function() {
      clearTimeout(debounceTimer);

      debounceTimer = setTimeout(() => {
        var term = input.val().trim();
        var form = input.closest('form');
        var searchURL = '/search?type=product&q=' + encodeURIComponent(term);

        // Clear if less than 3 chars
        if (term.length <= 2) {
          resultsList.empty();
          summary.empty();
          wrapper.hide();
          input.attr('data-old-term', '');
          return;
        }

        if (term === input.attr('data-old-term')) return;
        input.attr('data-old-term', term);

        if (currentAjaxRequest) currentAjaxRequest.abort();

        currentAjaxRequest = $.getJSON(searchURL + '&view=json', function(data) {
        // prevent stale results
        if (input.val().trim() !== term) return;

        resultsList.empty();
        summary.empty();

        if (data.results_count === 0) {
          summary.html('<p>No results found for <strong>' + term + '</strong></p>');
          resultsList.html('');
          wrapper.fadeIn(200);
        } else {

          // -------- SUMMARY (NO CHANGE) --------
          let matchedBrands = [];

          data.results.forEach(item => {
            if (item.vendor && item.vendor.toLowerCase().includes(term.toLowerCase())) {
              matchedBrands.push(highlightTerm(item.vendor, term));
            }
          });

          matchedBrands = [...new Set(matchedBrands)];

          if (matchedBrands.length > 0) {
            let brandsHtml = matchedBrands.map(b => {
              let vendorHandle = $('<div>').html(b).text().trim()
                .toLowerCase()
                .replace(/[^a-z0-9\s-]/g, '')
                .replace(/\s+/g, '-')
                .replace(/-+/g, '-');

              return `<span class="vendor-item">
                        <a href="/collections/${vendorHandle}" class="vendor-link">${b}</a>
                      </span>`;
            }).join('');

            summary.html(
              `<h6 class="search-vendors"><strong>Designers:</strong> ${brandsHtml}</h6>
              <p class="search-result-count"><upper>Products</upper> (${data.results_count} items found)</p>`
            );
          } else {
            summary.html(
              `<p class="search-result-count"><upper>Products</upper> (${data.results_count} items found)</p>`
            );
          }

          // -------- RESULTS (UPDATED PART) --------
          let totalImages = data.results.length;
          let loadedImages = 0;

          function checkAllImagesLoaded() {
            loadedImages++;
            if (loadedImages === totalImages) {
              wrapper.fadeIn(200);
              initSearchSlider();
            }
          }

          $.each(data.results, function(index, item) {
            var link = $('<a class="search-prod"></a>').attr('href', item.url);

            var img = $('<img />')
              .attr('src', item.thumbnail)
              .on('load error', checkAllImagesLoaded);

            link.append($('<span class="live-search-thumbnail"></span>').append(img));
            link.append('<span class="live-search-vendor">' + item.vendor + '</span>');
            link.append('<span class="live-search-title">' + item.title + '</span>');

            var li = $('<li class="search-result-items swiper-slide" role="option"></li>').append(link);
            resultsList.append(li);
          });

          if (data.results_count > 10) {
            resultsList.append(
              '<li class="view-all-search"><span class="title result">' +
              '<a href="' + searchURL + '">View All ' + data.results_count + ' Items</a>' +
              '</span></li>'
            );
          }

          if (totalImages === 0) {
            wrapper.fadeIn(200);
            initSearchSlider();
          }
        }
      });

      }, 300); // debounce delay
    });
  });

});



// $(function() {
//   var currentAjaxRequest = null;

//   function highlightTerm(text, term) {
//     if (!term) return text;
//     var regex = new RegExp('(' + term + ')', 'ig');
//     return text.replace(regex, '<strong>$1</strong>');
//   }

//   $('form[action="/search"]').css('position','relative').each(function() {
//     var input = $(this).find('input[name="q"]');
//     var offSet = input.position().top + input.innerHeight();

//     // Create wrapper for summary + results
//     var wrapper = $('<div class="search-wrapper"></div>')
//       .appendTo($(this))
//       .hide();

//     var summary = $('<div class="serach-drawer-details"></div>').appendTo(wrapper);
//     var resultsList = $('<ul class="search-results" role="listbox"></ul>').appendTo(wrapper);

//     input.attr('autocomplete', 'off');

//     let debounceTimer;
//     input.on('keyup change', function() {
//       clearTimeout(debounceTimer);

//       debounceTimer = setTimeout(() => {
//         var term = input.val().trim();
//         var form = input.closest('form');
//         var searchURL = '/search?type=product&q=' + encodeURIComponent(term);

//         // Clear if less than 3 chars
//         if (term.length <= 2) {
//           resultsList.empty();
//           summary.empty();
//           wrapper.hide();
//           input.attr('data-old-term', '');
//           return;
//         }

//         if (term === input.attr('data-old-term')) return;
//         input.attr('data-old-term', term);

//         if (currentAjaxRequest) currentAjaxRequest.abort();

//         currentAjaxRequest = $.getJSON(searchURL + '&view=json', function(data) {
//           // prevent stale results
//           if (input.val().trim() !== term) return;

//           resultsList.empty();
//           summary.empty();

//           if (data.results_count === 0) {
//             summary.html('<p>No results found for <strong>' + term + '</strong></p>');
//             resultsList.html('');
//             wrapper.fadeIn(200);
//           } else {
//             // Build summary

//             console.log('liveSearch');

//             // Collect all matching brand/title from results
//             let matchedBrands = [];

//             data.results.forEach(item => {
//               if (item.vendor && item.vendor.toLowerCase().includes(term.toLowerCase())) {
//                 matchedBrands.push(highlightTerm(item.vendor, term));
//               } else if (item.title && item.title.toLowerCase().includes(term.toLowerCase())) {
//                 matchedBrands.push(highlightTerm(item.title, term));
//               }
//             });

//             // Remove duplicates
//             matchedBrands = [...new Set(matchedBrands)];

//             // Build summary only if we have matches
//             if (matchedBrands.length > 0) {
//               let brandsHtml = matchedBrands.map(b => `<span>${b}</span>`).join('');
              
//               summary.html(
//                 `<h6>${brandsHtml}</h6>` +
//                 `<p class="search-result-count"><upper>Products</upper> (${data.results_count} items found)</p>`
//               );
//             } else {
//               // agar kuch match hi na ho to sirf count dikhana
//               summary.html(
//                 `<p class="search-result-count"><upper>Products</upper> (${data.results_count} items found)</p>`
//               );
//             }


//             // Build results
//             $.each(data.results, function(index, item) {
//               var link = $('<a class="search-prod"></a>').attr('href', item.url);
//               link.append('<span class="live-search-thumbnail"><img src="' + item.thumbnail + '" /></span>');
//               link.append('<span class="live-search-vendor">' + item.vendor + '</span>');
//               link.append('<span class="live-search-title">' + item.title + '</span>');
//               var li = $('<li class="search-result-items" role="option"></li>').append(link);
//               resultsList.append(li);
//             });

//             if (data.results_count > 10) {
//               resultsList.append(
//                 '<li class="view-all-search"><span class="title result"><a href="' + searchURL + '">View All Item</a></span></li>'
//               );
//             }

//             wrapper.fadeIn(200);
//           }
//         });
//       }, 300); // debounce delay
//     });
//   });
// });
